import React from 'react';
import './multi-modal-content.scss';

interface ImageContentProps {
  imageUrl: string;
  alt?: string;
  className?: string;
}

const ImageContent: React.FC<ImageContentProps> = ({
  imageUrl,
  alt = 'Message attachment',
  className = '',
}) => {
  return (
    <div className={`image-content ${className}`}>
      <a
        href={imageUrl}
        target='_blank'
        rel='noopener noreferrer'
        className='image-link'
      >
        <img src={imageUrl} alt={alt} className='message-image' />
      </a>
    </div>
  );
};

export default ImageContent;
